import React from "react";
import { ReactComponent as ddm } from "../../../assets/icons/ddm.svg";
import "./icon.scss";

export const AnimatedDDM: React.FC = () => {
  const IconComponent = ddm;
  return <IconComponent className="animated-ddm" />;
};
